module.exports = __webpack_public_path__ + "430ba2648467495c8e296bf17e85e849.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-1080.webp
// module id = 408
// module chunks = 0